import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import './AndaTableSkeleton.styles.scss';

/**
 * Skeleton component for ANDA Applications table section
 * Displays loading state for the ANDA data table only
 */
const AndaTableSkeleton: React.FC = () => {
  return (
    <div className="anda-table-skeleton">
      {/* ANDA Header Skeleton */}
      <div className="anda-header-skeleton">
        <Skeleton width="15rem" height="1.5rem" />
        <div className="pagination-skeleton">
          <Skeleton width="6rem" height="2rem" borderRadius="0.5rem" />
          <Skeleton width="8rem" height="1rem" />
          <Skeleton width="6rem" height="2rem" borderRadius="0.5rem" />
        </div>
      </div>

      {/* ANDA Table Skeleton */}
      <div className="anda-table-content-skeleton">
        {/* Table Header */}
        <div className="table-header-skeleton">
          {[1, 2, 3, 4, 5, 6].map(index => (
            <Skeleton key={index} width="8rem" height="1rem" />
          ))}
        </div>
        {/* Table Rows */}
        {[1, 2, 3, 4, 5].map(rowIndex => (
          <div key={rowIndex} className="table-row-skeleton">
            {[1, 2, 3, 4, 5, 6].map(colIndex => (
              <Skeleton key={colIndex} width="7rem" height="0.875rem" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AndaTableSkeleton;
